export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13545.60ea0a90.jpg";